import i18nMobile from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './locales/en';
import { ELanguage } from './i18n';
i18nMobile.use(initReactI18next).init({
    returnNull: false,
    fallbackLng: ELanguage.En,
    interpolation: { escapeValue: false },
    resources: {
        [ELanguage.En]: { translation: en }
    }
});
export { i18nMobile };
//# sourceMappingURL=i18n.mobile.js.map